// A'gong Navigation
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-agong-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-target');
      var overlay = targetId ? document.getElementById(targetId) : null;
      if (!overlay) return;

      var isOpen = overlay.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-agong-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#' || href.length < 2) return;

      var target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });

      // Close any open mobile overlay
      document.querySelectorAll('.agong-nav__mobile-overlay.is-open').forEach(function (overlay) {
        overlay.classList.remove('is-open');
      });
      document.querySelectorAll('[data-agong-nav-toggle][aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  });
});
